import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Skeleton } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

const TITLE_SKELETON_HEIGHT = 14;
const TITLE_SKELETON_WIDTH = 64;
const TITLE_ROW_HEIGHT = 40;
const ROW_SKELETON_HEIGHT = 12;

const VARIANT_PACK_CARD_COUNT = 3;
const VARIANT_PACK_QUANTITY_WIDTH = 56;
const VARIANT_PACK_QUANTITY_HEIGHT = 28;

const VARIANT_PACK_CARD_ROWS: ReadonlyArray<`${number}%`> = [
  '60%',
  '36%',
  '50%',
];

export const VARIANT_PACK_SKELETON_A11Y_LABEL =
  'item-detail-variant-pack-skeleton';

/**
 * Loading placeholder for the Details-tab related-variant-packs list — a title
 * row plus a few card skeletons matching the section the user is waiting on.
 */
export const VariantPackListSkeleton: React.FC = () => {
  const [styles, theme] = useStyles();
  return (
    <View
      accessibilityLabel={VARIANT_PACK_SKELETON_A11Y_LABEL}
      accessibilityRole="progressbar"
      style={styles.variantPackSection}
    >
      <View style={styles.titleRow}>
        <Skeleton
          borderRadius={theme.sk.radii.radiusLarge}
          height={TITLE_SKELETON_HEIGHT}
          width={TITLE_SKELETON_WIDTH}
        />
      </View>
      <View style={styles.variantPackCards}>
        {Array.from({ length: VARIANT_PACK_CARD_COUNT }).map((_, index) => (
          <View key={index} style={styles.variantPackCard}>
            <View style={styles.variantPackCardText}>
              <Skeleton
                borderRadius={theme.sk.radii.radiusLarge}
                height={ROW_SKELETON_HEIGHT}
                width={
                  VARIANT_PACK_CARD_ROWS[index] ?? VARIANT_PACK_CARD_ROWS[0]
                }
              />
              <Skeleton
                borderRadius={theme.sk.radii.radiusLarge}
                height={ROW_SKELETON_HEIGHT}
                width={VARIANT_PACK_CARD_ROWS[1]}
              />
            </View>
            <Skeleton
              borderRadius={theme.sk.radii.radiusMedium}
              height={VARIANT_PACK_QUANTITY_HEIGHT}
              width={VARIANT_PACK_QUANTITY_WIDTH}
            />
          </View>
        ))}
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  titleRow: {
    alignItems: 'center',
    flexDirection: 'row',
    height: TITLE_ROW_HEIGHT,
  },
  variantPackCard: {
    alignItems: 'center',
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSMedium,
    justifyContent: 'space-between',
    paddingHorizontal: theme.sk.spacing.spaceSMedium,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
  variantPackCards: {
    flexDirection: 'column',
    gap: theme.sk.spacing.spaceSmall,
  },
  variantPackCardText: {
    flex: 1,
    flexDirection: 'column',
    gap: theme.sk.spacing.spaceXsmall,
  },
  variantPackSection: {
    flexDirection: 'column',
  },
}));
